import { Feature } from 'geojson';
import { DrawMap, LatLng } from 'leaflet';
import { IAnnotationService } from '../annotation.service';
import { IBrushTypeOptions } from '../annotations.interface';
import { IFreeDrawSegmentationService } from '../freeDrawSegmentation.service';
import { AnnotationToolType } from '../submodules/annotationTypes/models/annotationToolType';
import { IAnnotationTypeOptions } from '../submodules/annotationTypes/models/annotationTypeOptions';
import { IUndoRedoHistory } from '../undoRedoHistory.service';
import { DrawBrush } from './DrawControl.models/Brush/Draw.Brush';
import { DrawPoint } from './DrawControl.models/Draw.point';
import { DrawPolygon } from './DrawControl.models/Draw.polygon';
import { DrawPolyLine } from './DrawControl.models/Draw.polyline';
import { DrawRectangle } from './DrawControl.models/Draw.rectangle';
import { DrawRotatedRectangle } from './DrawControl.models/Draw.rotatedRectangle';
import { DrawVector } from './DrawControl.models/Draw.vector';
import { IDrawer } from './DrawControl.models/IDrawer';

export const createDrawer = (
  map: DrawMap,
  annotationToolType: AnnotationToolType,
  color: string,
  fillOpacity: number,
  activeAnnotationTypeId: string | undefined,
  cursorPosition: LatLng | undefined,
  onDrawCreated: (geojson: Feature) => void,
  onDrawStarted: (geojson: Feature) => void,
  undoRedoHistory: IUndoRedoHistory,
  annotationService: IAnnotationService,
  freeDrawSegmentationService: IFreeDrawSegmentationService,
  options: IAnnotationTypeOptions | undefined,
  feature?: Feature
): IDrawer | null => {
  switch (annotationToolType) {
    case AnnotationToolType.POLYGON:
      return new DrawPolygon(map, onDrawCreated, undoRedoHistory, { shapeOptions: { color, fillOpacity, opacity: 1 } });
    case AnnotationToolType.ROTATEDRECTANGLE:
      return new DrawRotatedRectangle(map, onDrawCreated, undoRedoHistory, { shapeOptions: { color, fillOpacity, opacity: 1 } });
    case AnnotationToolType.RECTANGLE:
      return new DrawRectangle(map, onDrawCreated, undoRedoHistory, {
        shapeOptions: { color, fillOpacity, opacity: 1 },
        showArea: false,
      });
    case AnnotationToolType.POINT:
      return new DrawPoint(map, onDrawCreated, { color, opacity: 1, fill: false });
    case AnnotationToolType.VECTOR:
      return new DrawVector(map, onDrawCreated, undoRedoHistory, { shapeOptions: { color, opacity: 1 } });
    case AnnotationToolType.POLYLINE:
      return new DrawPolyLine(map, onDrawCreated, undoRedoHistory, { shapeOptions: { color, opacity: 1 } });
    case AnnotationToolType.BRUSH: {
      const brushOptions = options as IBrushTypeOptions;
      return new DrawBrush(
        map,
        cursorPosition,
        activeAnnotationTypeId,
        undoRedoHistory,
        annotationService,
        freeDrawSegmentationService,
        { color, fillOpacity, opacity: 1, data: feature, diameter: brushOptions.brushDiameter, mode: brushOptions.brushMode },
        onDrawCreated,
        onDrawStarted,
        brushOptions.onDiameterChange
      );
    }
    case AnnotationToolType.SELECT:
    default:
      return null;
  }
};
